import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import { notify } from '../services/notification'
import { errorHandler } from './error/errorHandler.action'
import { HTTP_STATUS } from '../constants/httpsStatus/httpsStatus'


//pgm all list Download Action 
export const dowloadpgmlistAction = (page, parm, value, criteria, fromDate, toDate) => async (dispatch) => {
  const baseUrl = `${process.env.REACT_APP_API_URL}${Url.PGM_LIST_EXCEL}`;
  const queryParams = new URLSearchParams();

  // Always include pgm_status
  queryParams.append("pgm_status", parm);

  // Optional: add criteria & value if present
  if (value && criteria) {
    queryParams.append(criteria, value);
  }

  // Optional: add date filters
  if (fromDate) {
    queryParams.append("created_from", fromDate);
  }

  if (toDate) {
    queryParams.append("created_to", toDate);
  }

  const finalUrl = `${baseUrl}?${queryParams.toString()}`;
  const headers = getHeaders();

  try {
    const response = await fetch(finalUrl, {
      method: 'GET',
      headers,
    });

    if (response.status === 200) {
      return response.blob(); // returns Excel file
    } else {
      notify.error('Failed to download file');
      return null;
    }
  } catch (error) {
    errorHandler(error);
    return null;
  }
};


export const dowloadpgmlist3wAction = (page, parm, isActive,value, criteria) => async (dispatch) => {
  let url; // Declare `url` only once.

  if (parm == "all") {
    url = 
      process.env.REACT_APP_API_URL +
      Url.PGM_LIST_3W_EXCEL +
      `?pgm_status=${parm}`; // Fixed redundant "?" and concatenation issues.
  }

  if (value) {
    url = 
      process.env.REACT_APP_API_URL +
      Url.PGM_LIST_3W_EXCEL +
      `?pgm_status=${parm}${criteria}=${value}&is_active=${isActive}`;
  }

  if (parm != "all") {
    url = 
      process.env.REACT_APP_API_URL +
      Url.PGM_LIST_3W_EXCEL +
      `?pgm_status=${parm}&is_active=${isActive}`;
  }

  if (parm != "all" && value) {
    url = 
      process.env.REACT_APP_API_URL +
      Url.PGM_LIST_3W_EXCEL +
      `?pgm_status=${parm}${criteria}=${value}&is_active=${isActive}`;
  }

  // const url = process.env.REACT_APP_API_URL + Url.PGM_LIST_EXCEL;
  const headers = getHeaders();

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (response.status === 200) {
      return response.blob();
    } else {
      notify.error('Failed to download file');
      return null
    }
  } catch (error) {
    errorHandler(error)
  }
};

export const dowloadRetaierlistAction = (queryParams) => async (dispatch) => {
  let url = process.env.REACT_APP_API_URL + Url.PGM_LIST_EXCEL;

  url = `${url}?${queryParams.toString()}`;
  
  const headers = getHeaders();
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (response.status === 200) {
      return response.blob(); // return blob for file download
    } else {
      notify.error('Failed to download file');
      return null;
    }
  } catch (error) {
    errorHandler(error);
  }
};


//pgm all list Download Action 
export const dowloadnotificationlistAction = (page, value, criteria) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + Url.NOTIFICATION_LIST_EXCEL + `?page=${page}&page_size=10` +"&"+`${criteria}=${value}`;
  const headers = getHeaders();

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (response.status === 200) {
      return response.blob();
    } else {
      notify.error('Failed to download file');
      return null
    }
  } catch (error) {
    errorHandler(error)
  }
};

//pgm all list Download Action 
export const dowloadsupportqueryAction = (fromDate, toDate, status) => async (dispatch) => {
  const url = `${process.env.REACT_APP_API_URL}${Url.SUPPORT_QUERY_EXCEL}?from_date=${fromDate}&to_date=${toDate}&status=${status}`;
  const headers = getHeaders();

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (response.status === 200) {
      return response.blob();
    } else {
      const errorData = await response.json();
      const errorMessage = errorData.error || 'Failed to download file';
      notify.error(errorMessage);
      return null;
    }
  } catch (error) {
    errorHandler(error);
  }
};

export const dowloadsupportquery3wAction = (fromDate, toDate, status) => async (dispatch) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const ENDPOINT = Url.SUPPORT_QUERY_3W_EXCEL;
 
  // Build query parameters dynamically
  const queryParams = new URLSearchParams();
  queryParams.append('from_date', fromDate);
  queryParams.append('to_date', toDate);
 
  // Add status to query parameters only if it is provided
  if (status) {
    queryParams.append('status', status);
  }
 
  const url = `${API_URL}${ENDPOINT}?${queryParams.toString()}`;
  const headers = getHeaders();
 
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });
 
    if (!(response.status === HTTP_STATUS.SUCCESS)) {
      const errorData = await response.json();
      const errorMessage = errorData.errors || 'Failed to download file';
      notify.error(errorMessage);
      return null;
    }

    return await response.blob();
  } catch (error) {
    errorHandler(error);
    return null;
  }
};


//pgm all list Download Action 
export const dowloadredemptionAction = () => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + Url.REDEMPTION_LIST_EXCEL;
  const headers = getHeaders();

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (response.status === 200) {
      return response.blob();
    } else {
      notify.error('Failed to download file');
      return null
    }
  } catch (error) {
    errorHandler(error)
  }
};

export const DowloadReportAction = (id, state, user, district, from_date, to_date,agency_code,user_type) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + Url.REPORTS + id + "?download=true" + (state ? "&state_id=" + state : "") + (user ? "&user_id=" + user : "") + (district ? "&district_id=" + district : "") + (from_date ? "&from_date=" + from_date : "") + (to_date ? "&to_date=" + to_date : "") + (agency_code ? "&agency_code=" + agency_code :"") + (user_type ? "&user_type=" + user_type :"");
  const headers = getHeaders();

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });
    if (response.status === 200) {
      return response.blob();
    } else {
      notify.error('Failed to download file');
      return null
    }
  } catch (error) {
    errorHandler(error)
  }
};